<div class="performance-lab-sec perf-new-layout">
  <div class="inner-nav">
    <div class="sub-menu collapsed" id="sub-menu" (mouseover)="expandMenu(submenu)" (mouseout)="collapseMenu(submenu)"
      #submenu>
      <div class="sidebar-header">
        <div class="sidebar-header-badge sidebar-title">
          <i class="icon fas fa-chart-line"></i>
          <span class="name">Performance</span>
        </div>
      </div>

      <ul class="sidebar-menu">
        <li>
          <a routerLink="/performance/loadTesting" title="Test" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">
            <i class="icon fas fa-cogs"></i>
            <span class="name">Test</span>
          </a>
        </li>
        <li>
          <a routerLink="/performance/loadTesting/queue" [queryParams]="{ page: 1, size: 15 }" title="Queue"
            routerLinkActive="active">
            <i class="icon fas fa-layer-group"></i>
            <span class="name">Queue</span>
          </a>
        </li>
        <li>
          <a routerLink="/performance/loadTesting/compare" [queryParams]="{ page: 1, size: 15 }" title="Compare"
            routerLinkActive="active">
            <i class="icon fas fa-not-equal"></i>
            <span class="name">Compare</span>
          </a>
        </li>
        <!-- <li>
          <a routerLink="/performance/loadTesting/jmx-upload" title="JMX Upload"
            routerLinkActive="active">
            <i class="icon fas fa-file-upload"></i>
            <span class="name">JMX Upload</span>
          </a>
        </li> -->
      </ul>

      <div class="sidebar-footer">
        <div class="sidebar-badge">
          <i class="fas fa-question-circle"></i>
          <span class="name"><a href="https://wiki.corp.adobe.com/display/Relay/04_Performance+Lab" target="_blank" style="color: inherit;">Need help ?</a></span>
        </div>
      </div>
    </div>
  </div>
  <div>
    <router-outlet></router-outlet>
  </div>
</div>